import React from "react";

export const PageLoader = ({ sm = false, testid = "page-loader" }) => (
  <div className={`md-page-loader${sm ? " sm" : ""}`} role="status" aria-label="Loading" data-testid={testid}>
    <div className="md-spinner" />
  </div>
);

export default PageLoader;
